var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPixel7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_527",
    "data-name": "Group 527",
    transform: "translate(-937 -262)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_157",
    "data-name": "Rectangle 157",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(937 262)",
    fill: "#3f4053"
  }), /*#__PURE__*/React.createElement("text", {
    id: "Pixel_Pro",
    "data-name": "Pixel Pro",
    transform: "translate(940.5 280.5)",
    fill: "#fff",
    fontSize: 16,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Pixel Pro")), /*#__PURE__*/React.createElement("text", {
    id: "_7",
    "data-name": 7,
    transform: "translate(960 326)",
    fill: "#fff",
    fontSize: 50,
    fontFamily: "HelveticaNeue-Bold, Helvetica Neue",
    fontWeight: 700
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "7")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPixel7);
export default __webpack_public_path__ + "static/media/pixel7.5ed5ca7984af14c0d656e4029eeed7a9.svg";
export { ForwardRef as ReactComponent };